import { render, staticRenderFns } from "./StoreUpdateCompany.vue?vue&type=template&id=2e8c76cc&scoped=true&"
import script from "./StoreUpdateCompany.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdateCompany.vue?vue&type=script&lang=ts&"
import style0 from "./StoreUpdateCompany.vue?vue&type=style&index=0&id=2e8c76cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c76cc",
  null
  
)

export default component.exports